import { func } from 'prop-types'

import noop from 'shared/utils/noop'
import OffCanvasBody from 'views/components/organisms/OffCanvas/OffCanvasBody'
import OffCanvasHeader from 'views/components/organisms/OffCanvas/OffCanvasHeader'
import { offCanvasCategory, shopLanguagesType } from 'views/utils/propTypes'

const OffCanvasView = ({
  data,
  language,
  goBackHandler,
  closeMenuHandler,
  goNextHandler,
}) => (
  <div
    className="o-OffCanvasView"
    aria-labelledby="OffCanvasViewHeader"
    data-clientside-hook="menu"
    style={data.style}
  >
    <OffCanvasHeader
      goBackHandler={goBackHandler}
      closeMenuHandler={closeMenuHandler}
      backButton
    />

    <OffCanvasBody
      data={data}
      goNextHandler={goNextHandler}
      language={language}
    />
  </div>
)

OffCanvasView.propTypes = {
  data: offCanvasCategory.isRequired,
  language: shopLanguagesType,
  goBackHandler: func,
  closeMenuHandler: func,
  goNextHandler: func,
}

OffCanvasView.defaultProps = {
  language: null,
  goBackHandler: noop,
  closeMenuHandler: noop,
  goNextHandler: () => noop,
}

export default OffCanvasView
